import type { TransactionReturnType } from "../types"
import type { Address } from "viem"
import type { Config } from "wagmi"
import { parseAbi } from "viem"

import { simulatedTransaction } from "../simulated-transaction"

/* eslint-disable */

type WrapNativeProps = {
  account: Address
  chainId: number
  config: Config
  nativeAddress: Address
  amount: bigint
}

export const wrapNative = async ({
  account,
  chainId,
  config,
  nativeAddress,
  amount,
}: WrapNativeProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: parseAbi(["function deposit() payable"]),
        account,
        address: nativeAddress,
        args: [],
        chainId,
        functionName: "deposit",
        value: amount,
      },
    })
    return result
  } catch (error: any) {
    console.error("wrapNative", error)
    return { success: false, error: error.message, code: error.code }
  }
}
